import { render, staticRenderFns } from "./dataModule.vue?vue&type=template&id=ad22f95a&"
import script from "./dataModule.vue?vue&type=script&lang=js&"
export * from "./dataModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports